// // import React from 'react';
// // import { Link } from 'react-router-dom';

// // const ProjectsInHand = () => {
// //   return (
// //     <div className="px-6 py-12 bg-white text-gray-800">
// //       <div className="max-w-4xl mx-auto text-start">
// //         <h2 className="text-3xl font-bold mb-6">Projects In Hand</h2>
// //         <p className="text-lg leading-relaxed">
// //           <strong>PACIFIC BUILDERS (PVT) LTD</strong> is actively working on several high-profile projects across various sectors. Some of the notable ongoing works include:
// //           <snap className="text-blue-500 font-medium">Variant Apartment Building</snap>,
// //           <snap className="text-blue-500 font-medium">Union Tower, Sialkot</snap>.
// //         </p>
// //       </div>

// //       <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10 max-w-4xl mx-auto text-[18px]">
// //         <ul className="space-y-2 text-teal-700 font-semibold list-disc list-inside">
// //           <li>
// //             <Link to="/building-29A" className="text-teal-700">Variant Apartment Building</Link>
// //           </li>
// //         </ul>
// //         <ul className="space-y-2 text-teal-700 font-semibold list-disc list-inside">
// //           <li>
// //             <Link to="/uniont-tower" className="text-teal-700">Union Tower, Sialkot</Link>
// //           </li>
// //         </ul>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ProjectsInHand;


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const AllProjects = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const [filter, setFilter] = useState("all");
  const [showAll, setShowAll] = useState(false); // State to toggle between 'all' projects and '6' projects.

  const projects = [
    { title: "Variant Apartment Building at Plot No. 23/24, Lahore", img: "/images/Picture53.jpg", type: "complete", link: "/building-23A" },
    { title: "Boulevard Heights, Lahore", img: "/images/Profile5.jpg", type: "complete", link: "/boulevard-heights" },
    { title: "M.A. Jinnah Mosque, Bahria Orchard-2, Lahore", img: "/images/Picture35.jpg", type: "complete", link: "/m.a-jinnah-mosque" },
    { title: "Commercial Building, 3-Tariq Block, Lahore", img: "/images/Picture62.jpg", type: "complete", link: "/tariq-block" },
    { title: "Islamic Research Centre, Lahore", img: "/images/Picture58.jpg", type: "complete", link: "/islamic-research-centre" },
    { title: "Sitara Sapna City, Faisalabad", img: "/images/Profile6.jpg", type: "complete", link: "/sitara-sapna" },
    { title: "Bahria Orchard-4 School, Lahore", img: "/images/Profile3.jpg", type: "complete", link: "/boahria-orchard" },
    { title: "Dar-ul-Shifa Hospital, Faisalabad", img: "/images/Profile.jpg", type: "complete", link: "/dar-ul-shifa" },
    { title: "Five Star Textiles", img: "/images/Picture74.jpg", type: "complete", link: "/five-star-textiles" },
    { title: "City Center, Multan", img: "/images/Profile7.jpg", type: "complete", link: "/city-center" },
    { title: "Five Star International", img: "/images/Picture45.jpg", type: "complete", link: "/five-star" },
    { title: "Masjid Al Hussain, Bahria Town, Lahore", img: "/images/Picture75.jpg", type: "complete", link: "/masjid-al-hussain" },
    { title: "Residential Villas (Islamabad & Lahore)", img: "/images/Profile8.jpg", type: "complete", link: "/residential-villas" },
    { title: "Variant Apartment Building at Plot No. 29, Gulberg III", img: "/images/Picture33.jpg", type: "complete", link: "/building-29A" },

    // Running projects (you can update titles and links similarly)
    { title: "Union Tower Sialkot", img: "/images/Profile4.jpg", type: "running", link: "/uniont-tower" },
    { title: "Aura Tower 3G Gulberg 2 Lahore", img: "/images/mainaura.jpeg", type: "running", link: "/auratower" },
  ];


  // Filter projects based on selected type
  const filteredProjects = filter === "all" ? projects : projects.filter(project => project.type === filter);

  // Show only the first 6 projects initially if 'showAll' is false
  const projectsToShow = showAll ? filteredProjects : filteredProjects.slice(0, 6);

  return (
    <div className="wrapper">
      {/* Portfolio Section */}
      <section className="portfolio py-12">
        <div className="container mx-auto">
          <div className='w-[90%] mx-auto' data-aos="fade-right">

            <h2 className="text-4xl font-bold text-center text-teal-700 mb-4">
              Our Projects
            </h2>
            <p className="lg:w-[80%] mx-auto text-center text-lg mb-12">
              At PACIFIC BUILDERS (PVT) LTD, each project reflects our dedication to excellence, innovation, and timely delivery. From luxury villas to large-scale commercial developments, we bring visions to life with precision and professionalism.
            </p>


          </div>
          {/* <div className="text-center mb-8">
            <p className="text-4xl">Our Projects</p>
            <h2 className="text-3xl font-bold">Visit Our Projects</h2>
          </div> */}

          {/* Filter Buttons */}
          {/* Filter Buttons */}
          <ul className="flex justify-center space-x-4 mb-8">
            <li>
              <button
                className={`px-4 py-2 uppercase text-sm font-medium rounded-md transition-all 
        ${filter === "all" ? "bg-gradient-to-b from-[#1BB095] to-teal-900 text-white" : "bg-[#030f27] text-white"}`}
                onClick={() => setFilter("all")}
              >
                All
              </button>
            </li>
            <li>
              <button
                className={`px-4 py-2 uppercase text-sm font-medium rounded-md transition-all 
        ${filter === "complete" ? "bg-gradient-to-b from-[#1BB095] to-teal-900 text-white" : "bg-[#030f27] text-white"}`}
                onClick={() => setFilter("complete")}
              >
                Complete
              </button>
            </li>
            <li>
              <button
                className={`px-4 py-2 uppercase text-sm font-medium rounded-md transition-all 
        ${filter === "running" ? "bg-gradient-to-b from-[#1BB095] to-teal-900 text-white" : "bg-[#030f27] text-white"}`}
                onClick={() => setFilter("running")}
              >
                Running
              </button>
            </li>
          </ul>


          {/* Projects Grid */}
          <div className="w-[90%] mx-auto grid sm:grid-cols-2 md:grid-cols-3 gap-8">
            {projectsToShow.map((project, idx) => (
              <div key={idx} className="relative group overflow-hidden shadow-lg rounded-lg" data-aos="zoom-in-down">
                <img
                  src={project.img}
                  alt={project.title}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-[rgba(3,15,39,0.7)] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <Link
                    to={project.link}
                    className="w-[60px] h-[60px] bg-white text-[#030f27] text-5xl font-thin flex items-center justify-center transition duration-300 group-hover:bg-gradient-to-b from-[#1BB095] to-teal-900 group-hover:text-white"
                  >
                    +
                  </Link>
                </div>

                {/* Title Bar */}
                <div className="h-[60px] flex items-center bg-gradient-to-b from-[#1BB095] to-teal-900 text-white  overflow-hidden whitespace-nowrap text-ellipsis">
                  <h3 className="w-full text-center px-6 text-white font-bold text-lg truncate">{project.title}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* Load More Button */}
          <div className="text-center mt-8">
            <button
              className="px-6 py-3 bg-gradient-to-b from-[#1BB095] to-teal-900 text-white font-medium rounded-md transition duration-300 hover:bg-[#030f27] hover:text-white hover:from-none hover:to-none"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? "Less View" : "Load More"}
            </button>
          </div>
        </div>
      </section>



    </div>
  );
};

export default AllProjects;